import { render } from "./Metrics.vue?vue&type=template&id=d70f847a"
import script from "./Metrics.vue?vue&type=script&lang=js"
export * from "./Metrics.vue?vue&type=script&lang=js"

import "./Metrics.vue?vue&type=style&index=0&id=d70f847a&lang=css"
script.render = render

export default script